import Api from '@/services/Api';

export default {
  getEvents(tentacle, filter) {
    return Api().get(`/events?tentacle=${tentacle}&filter=${filter}`);
  }
};
